import React, { useState } from "react";
import TaskTimeslot from "./TaskTimeslot";
import { Droppable } from "react-beautiful-dnd";

export default function TaskTimeslotContainer({ tasks, setComplete, date }) {
  return (
    <div style={{ flexGrow: 1 }}>
      <Droppable droppableId={date.toISOString()}>
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={{ height: "100%" }}
          >
            {tasks.map((t, i) => (
              <TaskTimeslot task={t} index={i} setComplete={setComplete} />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
}
